import { useState, useContext } from 'react'
import { Box, Grid, LinearProgress,Radio, Paper, Stack, SvgIcon, Typography } from '@mui/material'
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CustomToolTip from '../../common/toolTip';
import { DataContext, DataDispatchContext } from '../../../contexts/data/dataContext'
import custom from '../../../styles/mui/szVariables.json'
import { analyticsDomain, analyticsCta } from '../../../services/constants'
import { sendClickAnalytics } from '../../common/util/util'

export default function MonitorUsageCard({ id, monitor, content }: any) {
    const border = custom.border
    const dispatch: any = useContext(DataDispatchContext)
    const data: any = useContext(DataContext)
    const [selectedValue, setSelectedValue] = useState(data?.monitorSelected[monitor]);

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const val = event.target.value
        setSelectedValue(val);
        const value: any = content[val]
        if(!value.icon) value.icon = content.icon
        value.cardTitle = content.cardTitle
        value.desc = content[val].cardDesc || value.desc
        dispatch({
            type: 'setDashboardCardValue',
            id, monitor,
            selected: val,
        })
        let name = id+monitor;
        if(id==='homeUsage' && val==="value1"){
            name = analyticsCta.monitorHomeUsageSolar
        }
        if(id==='homeUsage' && val==="value2"){
            name = analyticsCta.monitorHomeUsageGrid
        }
        if(id==='solarUtilization' && val==="value1"){
            name = analyticsCta.monitorSolarUtilizationHouseAndBattery
        }
        if(id==='solarUtilization' && val==="value2"){
            name = analyticsCta.monitorSolarExportedToGrid
        }
        sendClickAnalytics('/rightPanel', {
                domain: analyticsDomain.monitorToday,
                name,
                metadata: {},
            })   
    };

    const getId = (id: string) => {
        return `${id}`.replaceAll(' ','').replaceAll('&','And')
    }

    return (
        <Paper id={monitor+'Monitor'} elevation={0} 
            sx={{ 
                borderRadius: custom.corners6, 
                mx: custom.spacing.sm,
                mt: custom.spacing.sm,
                p: custom.spacing.md,
                width: "100%" 
            }} >     
            <Grid container 
                    direction="column" 
                    justifyContent="start" 
                    alignItems="flex-left" 
                    display="flex" >
                    <Grid item mb={custom.spacing.md}>
                        <Stack alignItems="center" 
                                direction="row" 
                                justifyContent="flex-end">
                            <Typography sx={{ 
                                    color: 'text.secondary' 
                                }} 
                                variant="szHeading.Bold.xSmall" 
                                    id={monitor+'Title'}>
                                    {content.monitorTitle}
                            </Typography>
                            <CustomToolTip message={content.toolTip} offset={[0,-10]}>
                                <Box component={"img"} 
                                    id="tooltipIcon"
                                    ml="auto" 
                                    p={custom.spacing.xxxs}    
                                    alt="info icon"
                                    src="/images/information.svg"
                                />
                            </CustomToolTip>
                        </Stack>
                    </Grid>
                    <Grid item mb={custom.spacing.sm}>
                        <Stack alignItems="center" 
                                direction="row" 
                                justifyContent="flex-end" >
                            <Box>
                                <Typography variant="szHeading.Bold.xLarge" 
                                    id={monitor+'Percent'}>
                                    {content[selectedValue].value}
                                    <Typography pl={custom.spacing.xxxxs} 
                                        variant="szHeading.Bold.xSmall" >
                                            {content[selectedValue].unit}
                                    </Typography>
                                </Typography>
                                <Typography 
                                    component={"p"} 
                                    variant="szHeading.Bold.xSmall" 
                                    id={monitor+'Description'}>
                                    {content[selectedValue].cardDesc}
                                </Typography>
                            </Box>
                            <SvgIcon sx={{ 
                                ml:'auto', 
                                fontSize: '2.5em', 
                                color: `${content.color}.main` }}> 
                                {content.icon} 
                            </SvgIcon>
                        </Stack>
                    </Grid>
                    <Grid item>
                        <Box width={"100%"} id={monitor+'Progressbar'}>
                            <LinearProgress variant="determinate" 
                                value={content[selectedValue].value} 
                                color={content.color}
                                sx={{
                                    height: '24px',
                                    borderRadius: custom.corners2,
                                    backgroundColor: 'sz.colors.surfaceWellSmall'
                                }}/>
                        </Box>
                    </Grid>
                    <Grid item my={custom.spacing.sm}>
                        <Paper elevation={0} sx={{ 
                                borderRadius: 
                                custom.corners4, 
                                border,
                                pr: custom.spacing.sm,
                                pl: custom.spacing.xxxs,
                                py: custom.spacing.xxs 
                            }}>
                            <Stack alignItems="center" 
                                direction="row" 
                                justifyContent="flex-end"
                                borderBottom={border}>
                                <Radio
                                    id={getId(`${content.value1.desc}Radio`)}
                                    checkedIcon={<CheckCircleIcon 
                                            sx={{ color: `${content.color}.main` }} 
                                        />}
                                    checked={selectedValue === 'value1'}
                                    onChange={handleChange}
                                    value="value1"
                                    name="radio-buttons"
                                />
                                <Typography variant="szBody.Regular.Small" 
                                    id={getId(`${content.value1.desc}Text`)}>
                                    {content.value1.desc}
                                </Typography>
                                <Typography ml="auto" component={"h4"} 
                                    variant="szBody.Bold.Medium" 
                                    id={getId(`${content.value1.desc}Value`)}>
                                        {content.value1.value}{content.value1.unit}
                                </Typography>
                            </Stack>
                            <Stack alignItems="center" 
                                    direction="row" 
                                    justifyContent="flex-end" >
                                <Radio
                                    id={getId(`${content.value2.desc}Radio`)}
                                    checkedIcon={<CheckCircleIcon 
                                        sx={{ color: `${content.color}.main` 
                                    }}/>} 
                                    checked={selectedValue === 'value2'}                         
                                    onChange={handleChange}
                                    value="value2"
                                    name="radio-buttons"
                                />
                                <Typography variant="szBody.Regular.Small" 
                                    id={getId(`${content.value2.desc}Text`)}>
                                    {content.value2.desc}
                                </Typography>
                                <Typography ml="auto" 
                                    variant="szBody.Bold.Medium" 
                                     id={getId(`${content.value2.desc}Value`)}>
                                    {content.value2.value}{content.value2.unit}
                                </Typography>
                            </Stack>
                        </Paper>
                    </Grid>
                    <Grid item >
                        <Typography color="text.secondary" 
                            variant="szBody.Regular.Small"
                            id={monitor+'Comments'}>
                           {content.comments}
                        </Typography>
                    </Grid>
            </Grid>
        </Paper>
    )
}